export const AIRCRAFT_FILTER_QUERY = gql`
  query AircraftFilterQuery($orgSlug: String!) {
    aircrafts(orgSlug: $orgSlug) {
      id
      tailNumber
    }
  }
`
